var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthentication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#authentication-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.824 13.684a2.775 2.775 0 0 1-2.682 2.078 2.771 2.771 0 0 1-2.682-2.078c.815.085 1.71.138 2.683.138.971 0 1.867-.053 2.681-.138zM8.143.524a4.849 4.849 0 0 1 4.848 4.848v1.55c0 1.204.568 2.34 1.532 3.062.569.427.47 1.26-.21 1.468-1.282.389-3.383.846-6.17.846s-4.888-.457-6.17-.846c-.68-.207-.78-1.04-.21-1.468a3.83 3.83 0 0 0 1.531-3.063V5.372A4.848 4.848 0 0 1 8.143.524z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "authentication-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthentication);
export default __webpack_public_path__ + "static/media/authentication.7920c8dc334fdab7329c1e1c7f8d15a9.svg";
export { ForwardRef as ReactComponent };